
import React from 'react';
import localization from '../helpers/localization.js';
import MeasurementLine from '../saunaImageElements/measurementLine.js';
import Door from '../saunaImageElements/door.js';
import Stove from '../saunaImageElements/stove.js';
import Bench from '../saunaImageElements/bench.js';
import { Stage, Layer, Rect } from 'react-konva';
import Modal from 'react-modal';


let offset = 150;
const modalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class SelectDoorAndStovePostitionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false };

    }
    render() {
        return (<div className="page" id="positioningPage">
            {this.RenderStage()}
            <Modal isOpen={this.state.showModal} style={modalStyle}>
                <label>{this.state.modalLabel || "Anna mitta"}</label>
                <input type="number" defaultValue={this.state.modalValue} onChange={(sender) => this.modalInputChanged(this.clamp(parseInt(sender.target.value) || 0, this.state.modalMinValue, this.state.modalMaxValue))} min={this.state.modalMinValue} max={this.state.modalMaxValue} />
                <button onClick={this.closeModal.bind(this)}>Sulje</button>
            </Modal>
            <h1>{this.getInstructionText()}</h1>
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => { this.props.prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => { this.props.nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
        </div>
        );
    }
    renderStove(scale, offset, saunaWidth, saunaDepth) {
        if (this.props.drawStove) {
            return (<Stove
                scale={scale}
                stove={{ width: 650, depth: 650 }}
                stoveImage={this.props.stoveImage}
                stovex={this.props.measurements.stovePosition.x}
                stovey={this.props.measurements.stovePosition.y}
                rotation={this.props.stoveRotation}
                offset={{ x: offset, y: offset }}
                draggable={!this.props.lockStovePosition}
                saunaWidth={saunaWidth}
                saunaDepth={saunaDepth}
                stovePositionUpdated={(e) => { this.props.stovePositionUpdated(e); }}>
            </Stove>);
        }
    }
    RenderStage() {
        let saunaWidth = parseInt(this.props.measurements.doorWallWidth, 10);
        let saunaDepth = parseInt(this.props.measurements.depth, 10);
        let doorWidth = parseInt(this.props.measurements.doorWidth, 10);
        let doorFromLeft = parseInt(this.props.measurements.doorFromLeft, 10);
        let scale = 1;
        let width = 1;
        let height = 1;
        let parent = document.getElementById("positioningPage")
        offset = Math.max(saunaDepth * 0.1, saunaWidth * 0.1);
        if (parent) {
            width = parent.clientWidth;
            height = parent.clientHeight;
        }
        else {
            width = 800;
            height = 800;
        }
        let requiredHeightSclaling = height / (offset * 2 + saunaDepth + doorWidth);
        let requiredWidthScaling = width / (offset * 2 + saunaWidth);
        scale = Math.min(requiredHeightSclaling, requiredWidthScaling);
        height = (offset * 2 + saunaDepth + doorWidth) * scale;
        if (saunaWidth && saunaDepth && doorWidth) {
            return (<Stage scaleX={scale} ref={(stage) => { this.stage = stage }} scaleY={scale} width={width} height={height}>
                <Layer ref={(layer) => { this.layer = layer }} id="benchCadCanvas" >
                    <Rect x={0} y={0} width={width} height={height} fill="white" scaleY={1 / scale} scaleX={1 / scale} ></Rect>
                    <Rect x={offset} y={offset} width={saunaWidth} height={saunaDepth} stroke="black" fill="#D6DBDF" strokeWidth="8" preventDefault={false}></Rect>
                    {this.renderBench(offset)}
                    {this.renderStove(scale, offset, saunaWidth, saunaDepth)}
                    <Door scale={scale} startx={offset + doorFromLeft} offset={offset} draggable={!this.props.lockDoorPosition} doorHandness={this.props.measurements.doorHandness} onDoorClick={this.props.doorHandnessChanged} saunaWidth={saunaWidth} starty={offset + saunaDepth} doorWidth={doorWidth} doorFromLeftUpdated={(e) => { this.props.doorFromLeftUpdated(e); }} onDragEnd={this.saveImage} ></Door>
                    <MeasurementLine startx={offset} starty={offset + saunaDepth + +150} length={doorFromLeft} showModal={this.showMeasurementModal.bind(this)} inputChanged={(e) => { this.props.doorFromLeftUpdated(e); }}></MeasurementLine>
                    <MeasurementLine startx={offset + doorFromLeft + doorWidth} showModal={this.showMeasurementModal.bind(this)} inputChanged={(e) => { this.props.doorFromLeftUpdated(saunaWidth - doorWidth - e); }} starty={offset + saunaDepth + +150} length={saunaWidth - doorWidth - doorFromLeft}></MeasurementLine>
                    <MeasurementLine startx={offset} starty={offset} length={saunaWidth}></MeasurementLine>
                    <MeasurementLine startx={offset + saunaWidth} starty={offset} rotation={90} length={saunaDepth}></MeasurementLine>
                </Layer>
            </Stage>);
        }
        else {
            return <div></div>
        }
    }
    closeModal() {
        this.setState({ showModal: false });
    }
    showMeasurementModal(label, value, onchanged, minValue, maxValue) {
        this.setState({
            showModal: true,
            modalValue: value,
            modalLabel: label,
            modalMinValue: minValue,
            modalMaxValue: maxValue
        });
        this.modalInputChanged = onchanged;
    }
    clamp(value, min, max) {     
       if (value < min) value = min;
       /* else if (value > max) value = max;*/
        return value;
    }
    renderBench(offset) {
        return <Bench x={offset} y={offset} benchImage={this.props.benchImage}></Bench>
    }
    getInstructionText() {
        if (!this.props.lockDoorPosition && !this.props.lockStovePosition) {
            if (this.props.drawBench) {
                return localization.dragDoorAndStoveToPlace;
            }
            else {
                return localization.dragDoorToPlace;
            }
        }
        else {
            return localization.checkMeasurements;

        }


    }
}


export default SelectDoorAndStovePostitionComponent;